import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="bg-[#f8f8f4] py-20">
      <div className="container-app mx-auto max-w-4xl px-4 text-center">
        <h1 className="text-3xl font-bold text-gray-900">Seite nicht gefunden (404)</h1>
        <p className="mt-4 text-gray-700">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-block rounded-full border border-black bg-white px-5 py-2.5 text-sm font-medium text-black transition hover:bg-black hover:text-white"
          >
            Zur Startseite
          </Link>
          <Link
            to="/medical"
            className="inline-block rounded-full border border-black bg-white px-5 py-2.5 text-sm font-medium text-black transition hover:bg-black hover:text-white"
          >
            REPEXO Medical
          </Link>
          <Link
            to="/sales"
            className="inline-block rounded-full border border-black bg-white px-5 py-2.5 text-sm font-medium text-black transition hover:bg-black hover:text-white"
          >
            REPEXO Sales
          </Link>
        </div>
      </div>
    </section>
  );
}
